import { render, staticRenderFns } from "./CustomDropDown.vue?vue&type=template&id=02f2cb97&scoped=true"
import script from "./CustomDropDown.vue?vue&type=script&lang=js"
export * from "./CustomDropDown.vue?vue&type=script&lang=js"
import style0 from "./CustomDropDown.vue?vue&type=style&index=0&id=02f2cb97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f2cb97",
  null
  
)

export default component.exports